import axios from "axios";

const state = {
  FAQ: null,
};

const getters = {
  retrieveFAQ: (state) => {
    if (state.FAQ) {
      return state.FAQ;
    } else {
      return false;
    }
  },
};

const actions = {
  async getFAQ({ commit }) {
    console.log(" -- Get FAQ");
    let stringPayload = JSON.stringify({
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    });
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    const FAQResult = await axios
      .post("get-all-faq", params)
      .then((response) => {
        if (response.data.success == true) {
          commit("setFAQ", response.data);
          return response.data.success;
        } else {
          return response.data.success;
        }
      })
      .catch((e) => {
        console.log(e);
        return false;
      });

    return FAQResult;
  },

  clearFAQ({ commit }) {
    commit("setFAQ", null);
  },
};

const mutations = {
  //setFAQ: (state, FAQ) => Object.assign(state, FAQ),
  setFAQ: (state, FAQ) => (state.FAQ = FAQ),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
